import englishTranslations from './translations/en.json';

const translations = {
    en: englishTranslations,
    'en-us': englishTranslations
};

export default translations;
